export const iconOptions = [
    // Public and Private Works
    { label: "Obras Públicas", value: "fas fa-road" },
    { label: "Obras Privadas", value: "fas fa-building" },

    // Commercial and Educational
    { label: "Centros Comerciales", value: "fas fa-shopping-cart" },
    { label: "Instituciones Educativas", value: "fas fa-graduation-cap" },

    // Healthcare
    { label: "Hospitales", value: "fas fa-hospital" },

    // Residential Areas
    { label: "Pisos", value: "fas fa-th" },
    { label: "Baños", value: "fas fa-bath" },
    { label: "Cocinas", value: "fas fa-utensils" },

    // Outdoor Areas
    { label: "Exteriores", value: "fas fa-tree" },
    { label: "Jardines", value: "fas fa-seedling" },
    { label: "Piscinas", value: "fas fa-swimming-pool" },
    { label: "Garajes", value: "fas fa-car" },
    { label: "Áreas de Juego", value: "fas fa-child" },

    // Interior Design
    { label: "Iluminación", value: "fas fa-lightbulb" },
    { label: "Muebles", value: "fas fa-couch" },
    { label: "Decoración", value: "fas fa-paint-brush" },

    // Fitness and Recreation
    { label: "Gimnasios", value: "fas fa-dumbbell" },
    { label: "Salas de Cine", value: "fas fa-film" },
    { label: "Salones de Juegos", value: "fas fa-gamepad" },

    // Offices and Workspaces
    { label: "Oficinas", value: "fas fa-briefcase" },
    { label: "Salas de Reuniones", value: "fas fa-handshake" },
    { label: "Coworking", value: "fas fa-users" },

    // Cultural and Leisure
    { label: "Bibliotecas", value: "fas fa-book" },
    { label: "Museos", value: "fas fa-landmark" },
    { label: "Teatros", value: "fas fa-theater-masks" },
    { label: "Salas de Cine", value: "fas fa-film" },
    { label: "Estadios", value: "fas fa-futbol" },

    // Travel and Accommodation
    { label: "Hoteles", value: "fas fa-hotel" },
    { label: "Aeropuertos", value: "fas fa-plane" },
    { label: "Estaciones de Tren", value: "fas fa-train" },
    { label: "Estaciones de Autobús", value: "fas fa-bus" },
    { label: "Restaurantes", value: "fas fa-utensils" },

    // Nature and Outdoors
    { label: "Parques", value: "fas fa-park" },
    { label: "Playas", value: "fas fa-umbrella-beach" },
    { label: "Montañas", value: "fas fa-mountain" },
    { label: "Bosques", value: "fas fa-tree" },
    { label: "Lagos", value: "fas fa-water" },
    { label: "Ríos", value: "fas fa-water" },
    { label: "Cascadas", value: "fas fa-water" },
    { label: "Zoológicos", value: "fas fa-paw" },
    { label: "Acuarios", value: "fas fa-fish" }
];